import React from 'react';
import ResetPasswordForm from '../../components/ResetPassword';

const ResetPassword = () => {
    return (
        <div className="login-page">
            <div className="left-panel">
                <p className="left-text">Conversations Evolved. Intelligence Delivered.</p>
            </div>

            <div className="right-panel">
                <ResetPasswordForm />
            </div>
        </div>
    );
};

export default ResetPassword;